export default "__VITE_ASSET__109ecfa6__"